import { API_URL } from 'constants';
import { securityHeaders } from 'helpers/headers';

export const convertToCSV = (data) => {
  if (!data || data.length === 0) return '';

  const headers = Object.keys(data[0]).join(',');
  const rows = data.map((row) => Object.values(row).join(',')).join('\n');
  return `${headers}\n${rows}`;
};

export const downloadFile = (content, filename, mimeType) => {
  const blob = new Blob([content], { type: mimeType });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const exportData = async (endpoint, filename) => {
  try {
    const headers = securityHeaders();
    const response = await fetch(API_URL + endpoint, {
      method: 'GET',
      headers,
    });

    const contentType = response.headers.get('content-type');

    if (contentType?.includes('application/json')) {
      const jsonData = await response.json();
      if (!jsonData || jsonData.length === 0) {
        console.warn('No data available for export.');
        return;
      }

      const csvContent = convertToCSV(jsonData);
      downloadFile(csvContent, filename, 'text/csv');
    } else {
      const blob = await response.blob();
      downloadBlob(blob, filename);
    }
  } catch (error) {
    console.error('Error fetching export data:', error);
  }
};
